import { useMemo } from 'react';
import { Table } from '../../Table';
import type { BulkAction, SortDescriptor } from '../../Table';
import type { AttachCandidate } from './types';
import type { KindConfig } from './kindConfig';
import { buildColumns, candidateToRow } from './tableModel';

const ATTACH_ACTION: BulkAction[] = [{ id: 'attach', label: 'Attach to project' }];
const noop = async () => {};

export interface AttachCandidatesTableProps {
  config: KindConfig; rows: AttachCandidate[];
  onAttach: (ids: string[]) => Promise<void>;
}
export function AttachCandidatesTable({ config, rows, onAttach }: AttachCandidatesTableProps) {
  const columns = useMemo(() => buildColumns(config), [config]);
  const tableRows = useMemo(() => rows.map(candidateToRow), [rows]);
  const defaultSort: SortDescriptor = config.defaultSort;
  return (
    <Table
      columns={columns} rows={tableRows} defaultSort={defaultSort}
      onCellEdit={noop}
      onBulkAction={async (ids, action) => { if (action.id === 'attach') await onAttach(ids); }}
      bulkActions={ATTACH_ACTION} multiSelectEnabled
      dataTestId="attach-existing-modal-table"
    />
  );
}
